export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DesktopRegistrationHeader.vue?vue&type=template&id=bf8418e0&"


//////////////////
// WEBPACK FOOTER
// ./src/apps/desktop/components/DesktopRegistrationHeader.vue?vue&type=template&id=bf8418e0&
// module id = null
// module chunks = 